import React from "react";
import { Timeline } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleTimelineProps extends React.ComponentProps<typeof Timeline> {
  useEditorTheme?: boolean;
}

const TrebbleTimeline = ({ useEditorTheme, ...restProps }: TrebbleTimelineProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Timeline {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleTimeline;
